import { render, staticRenderFns } from "./art_list.vue?vue&type=template&id=737b8b7a&scoped=true&"
import script from "./art_list.vue?vue&type=script&lang=js&"
export * from "./art_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737b8b7a",
  null
  
)

export default component.exports